export const KEY_TIME_RANGE = 'timeRange'
export const DEFAULT_TIME_RANGE = 'today'
